import { Controller } from "@hotwired/stimulus";

// The trend chart's tooltip; each column carries its title and rows as data attributes.
export default class extends Controller {
  static targets = ["tooltip"];

  show(event) {
    const { tipTitle, tipRows } = event.currentTarget.dataset;
    const rows = JSON.parse(tipRows || "[]");
    const tooltip = this.tooltipTarget;
    tooltip.replaceChildren(this.title(tipTitle), ...rows.map((row) => this.row(row)));
    tooltip.classList.remove("hidden");
    this.move(event);
  }

  move(event) {
    const bounds = this.element.getBoundingClientRect();
    const tooltip = this.tooltipTarget;
    const left = Math.min(event.clientX - bounds.left + 14, bounds.width - tooltip.offsetWidth - 4);
    tooltip.style.left = `${Math.max(0, left)}px`;
    tooltip.style.top = `${Math.max(0, event.clientY - bounds.top - tooltip.offsetHeight - 12)}px`;
  }

  hide() {
    this.tooltipTarget.classList.add("hidden");
  }

  title(text) {
    const element = document.createElement("div");
    element.className = "mb-1 font-semibold";
    element.textContent = text;
    return element;
  }

  row({ label, color, value }) {
    const element = document.createElement("div");
    element.className = "flex items-center justify-between gap-3";
    const name = document.createElement("span");
    name.className = "inline-flex items-center gap-1.5";
    const swatch = document.createElement("span");
    swatch.className = "inline-block h-2 w-2 rounded-sm";
    swatch.style.background = color;
    name.append(swatch, document.createTextNode(label));
    const count = document.createElement("span");
    count.className = "tabular-nums";
    count.textContent = Number(value).toLocaleString();
    element.append(name, count);
    return element;
  }
}
